import { useAuth } from '@/contexts/Auth'
import { subscribeTenantMaintenance, type TenantMaintenance } from '@/services/tenant-maintenance'
import { useEffect, useState } from 'react'

const MAINTENANCE_OFF: TenantMaintenance = { enabled: false, endAt: null, updatedAt: null }

/**
 * The current tenant's maintenance state (toggled from FitUP Commander,
 * stored in Firestore). Updates in real time.
 */
export const useTenantMaintenance = (): TenantMaintenance => {
  const { tenantId } = useAuth()
  const [maintenance, setMaintenance] = useState<TenantMaintenance>(MAINTENANCE_OFF)

  useEffect(() => {
    if (!tenantId) {
      setMaintenance(MAINTENANCE_OFF)
      return
    }
    return subscribeTenantMaintenance(
      tenantId,
      setMaintenance,
      // Fail open: a Firestore read error (offline, rules) must not lock
      // every user out of the app.
      () => setMaintenance(MAINTENANCE_OFF)
    )
  }, [tenantId])

  return maintenance
}
